import css from "styled-jsx/css";
import colors from "styles/colors";
import { MARKETING_RED_COLOR_NAME } from "styles/color-consts";
import { LAYER_ONE } from "constants/z-index";
import { getComponentShadowFilter } from "segments/desktop/constants";

export const componentStyles = css`
  .product-card {
    width: 286px;
    z-index: ${LAYER_ONE};
    padding: 32px 24px;
    margin: 32px 10px 0;
    border-radius: 8px;
    background-color: white;
    filter: ${getComponentShadowFilter(0.16)};
    transition: filter 0.2s ease-in-out;
    &:hover {
      filter: ${getComponentShadowFilter(0.32)};
    }
    .product-card-header {
      margin-bottom: 32px;
      .product-card-header-image {
        height: 51px;
        margin-bottom: 5px;
        :global(img) {
          max-height: 51px;
        }
      }
      .product-card-header-subtitle {
        font-size: 14px;
        opacity: 0.5;
      }
    }
    .product-card-body {
      font-weight: lighter;
      line-height: 1.5;
    }  
    .product-card-divider {
      box-sizing: content-box;
      border-width: 1px;
      border-style: solid;
      border-image: linear-gradient(to right, #ff158aff, #ff158a00);
      border-image-slice: 1;
      margin-bottom: 20px;
      margin-top: 32px;
    }
    .product-card-use-cases {
      .product-card-use-cases-title {
        margin-bottom: 12px;
        font-size: 14px;
      }
      .product-card-use-cases-bullets {
        display: flex;
        margin-bottom: 20px;
        flex-direction: column;
        .product-card-use-cases-bullet-icon-and-text {
          display: flex;
          margin-bottom: 5px;
          font-size: 14px;

          .product-card-use-cases-bullet-icon {
            color: ${colors[MARKETING_RED_COLOR_NAME]};
            margin-right: 5px;
          }
        }
      }
    }
    .product-card-footer {
      :global(.secondary-button) {
        font-size: 14px;
        :global(*) {
          font-weight: 500;
        }
      }
    }
  }
`;
